<template>
  <v-flex xs12 sm8 md4 lg4>
    <v-form>
      <v-card class="elevation-4 pa-3">
        <v-card-text>
          <div class="layout column align-center">
            <img
              src="@/assets/logo-120x120.png"
              :alt="sistem.app_title"
              height="120"
            />
            <h1
              class="mt-3 mb-5 display-1 font-weight-regular"
              :class="`${sistem.app_theme}--text`"
            >
              Reset Password
            </h1>
          </div>
          <template v-if="loading">
            <div class="layout align-center column" style="margin: 20px 0">
              <div class="subheading">Memeriksa kredensial...</div>
              <v-progress-linear
                style="width: 90%"
                color="primary"
                indeterminate
              >
              </v-progress-linear>
            </div>
          </template>
          <template v-else>
            <span class="font-weight-regular font-italic">
              Masukkan password Anda yang baru.
            </span>
            <v-text-field
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              :type="showPassword ? 'text' : 'password'"
              :append-icon-cb="() => (showPassword = !showPassword)"
              autofocus
              hint="*Password harus mengandung Huruf besar, Huruf kecil, Angka, dan Simbol"
              persistent-hint
              v-model="input.password"
              v-validate="'required|min:8|max:10|valid_password'"
              name="password"
              data-vv-name="password"
              label="Password"
              data-vv-as="Password"
              :error-messages="errors.collect('password')"
            >
            </v-text-field>
          </template>
        </v-card-text>
        <v-card-actions>
          <public-menus></public-menus>
          <v-spacer></v-spacer>
          <v-btn
            :color="sistem.app_theme"
            dark
            type="submit"
            @click.prevent="submit"
            >Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import PublicMenus from "@/components/public/PublicMenus";

export default {
  name: "reset-password",
  components: {
    PublicMenus
  },
  data() {
    return {
      input: {
        password: ""
      },
      loading: true,
      showPassword: false
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("sistem", ["sistem"])
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch("auth/RESET_PASSWORD", {
              id_user: this.$route.query.id,
              password: this.input.password
            })
            .then(() => {
              setTimeout(() => {
                this.$router.push({ name: "Login" });
              }, 1000);
            });
        }
      });
    }
  },
  mounted() {
    if (!(this.$route.query.id && this.$route.query.h)) {
      this.$router.push({ name: "AccessDenied" });
    } else {
      this.$store
        .dispatch("auth/RESOLVE_HASH", {
          id_user: this.$route.query.id,
          hash: this.$route.query.h
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.$router.push({ name: "AccessDenied" });
        });
    }
  }
};
</script>
